import { FunctionComponent, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { campaignController } from '@/apis/core';
import { Loader } from '@/shared_elements';
import {
  CNP_CAMPAIGN_DETAILS_PATH,
  CNP_RCS_CAMPAIGN_DETAILS_PATH,
  MY_CAMPAIGN_DETAILS_PATH,
  RCS_CAMPAIGN_DETAILS_PATH,
} from '@/constants/paths';
import { useAuthContext } from '@/contexts';

interface LocationState {
  goBackPage?: string;
}

interface CampaignRedirectorParams {
  id: string;
}

const CampaignRedirector: FunctionComponent = () => {
  const { profile } = useAuthContext();
  const history = useHistory();
  const { state } = useLocation<LocationState>();
  const { id } = useParams<CampaignRedirectorParams>();

  const redirect = async () => {
    if (id) {
      const campaign = await campaignController.getCampaignDetail(id);
      const isCnpCampaign = campaign?.cspUid !== profile?.uid;
      if (campaign) {
        if (campaign.channelId === 'RCS') {
          history.replace(
            (isCnpCampaign
              ? CNP_RCS_CAMPAIGN_DETAILS_PATH
              : RCS_CAMPAIGN_DETAILS_PATH
            ).replace(':id', id),
            state
          );
        } else {
          // Fallback to 10DLC
          history.replace(
            (isCnpCampaign
              ? CNP_CAMPAIGN_DETAILS_PATH
              : MY_CAMPAIGN_DETAILS_PATH
            ).replace(':id', id),
            state
          );
        }
      }
    }
  };

  useEffect(() => {
    redirect();
  }, [id]);

  return <Loader />;
};

export default CampaignRedirector;
